import envVar from '../config/envVars';
import httpDelete from './httpClient/httpDelete';
import httpPost from './httpClient/httpPost';

const getTerms = async (school: string) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/terms`,
    {},
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const getTermsForClass = async (
  school: string,
  academicYear: string,
  grade: string,
  division: string
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/terms`,
    { academicYear, grade, division },
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

interface UpsertTermPayload {
  name: string;
}

const upsertTerm = async (school: string, payload: UpsertTermPayload) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/terms/save`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const deleteTerm = async (termId: string) => {
  return httpDelete(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/terms/${termId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const termsApis = {
  getTerms,
  getTermsForClass,
  upsertTerm,
  deleteTerm
};

export default termsApis;
